import React, { useEffect, useState, Fragment } from "react";
import { useDispatch } from "react-redux";
import { Row, Col, Card, Button, Table } from "react-bootstrap";
import { Fn_FillListData, Fn_GetReport } from "../../store/Functions";
import { API_WEB_URLS } from "../../constants/constAPI";
import PageTitle from "../layouts/PageTitle";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

// Helper to format date string to DD-MM-YYYY
const formatShowDate = (dateStr) => {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return dateStr;
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  return `${day}-${month}-${year}`;
};

// Mock records matching Yearly/EPF1952.pdf
const MOCK_RECORDS = [
  { sno: 1, pfNo: "231", name: "SHIV SHANKER PUROHIT", totalWages: 176340.00, workerCont: 20724.00, epfDiff: 20724.00, pensionFund: 0.00, voluntaryCont: 0, ncpDays: 0.00 },
  { sno: 2, pfNo: "282", name: "KISHORE SINGH", totalWages: 96408.00, workerCont: 11568.00, epfDiff: 11568.00, pensionFund: 0.00, voluntaryCont: 0, ncpDays: 0.00 },
  { sno: 3, pfNo: "343", name: "MOHAMMAD ARIPH", totalWages: 106008.00, workerCont: 12720.00, epfDiff: 12720.00, pensionFund: 0.00, voluntaryCont: 0, ncpDays: 0.00 },
  { sno: 4, pfNo: "483", name: "NAGENDRA KUMAR RANGA", totalWages: 88920.00, workerCont: 10668.00, epfDiff: 10668.00, pensionFund: 0.00, voluntaryCont: 0, ncpDays: 0.00 },
  { sno: 5, pfNo: "616", name: "AMAR SINGH", totalWages: 95631.00, workerCont: 11475.00, epfDiff: 11475.00, pensionFund: 0.00, voluntaryCont: 0, ncpDays: 3.00 },
  { sno: 6, pfNo: "637", name: "VIJAY KUMAR SHARMA", totalWages: 179160.00, workerCont: 20964.00, epfDiff: 20964.00, pensionFund: 0.00, voluntaryCont: 0, ncpDays: 0.00 },
  { sno: 7, pfNo: "672", name: "RAJESH SHARMA", totalWages: 94652.00, workerCont: 11356.00, epfDiff: 3468.00, pensionFund: 7888.00, voluntaryCont: 0, ncpDays: 10.00 },
  { sno: 8, pfNo: "674", name: "ANUPAM KUMAR JHA", totalWages: 166380.00, workerCont: 19536.00, epfDiff: 5976.00, pensionFund: 13560.00, voluntaryCont: 0, ncpDays: 0.00 },
  { sno: 9, pfNo: "677", name: "KISHOR PANDIT", totalWages: 50330.00, workerCont: 6039.00, epfDiff: 6039.00, pensionFund: 0.00, voluntaryCont: 0, ncpDays: 53.00 },
  { sno: 10, pfNo: "678", name: "NARAYAN DAS VYAS", totalWages: 360000.00, workerCont: 43200.00, epfDiff: 43200.00, pensionFund: 0.00, voluntaryCont: 0, ncpDays: 0.00 },
  { sno: 11, pfNo: "689", name: "NAND KISHOR UPADHYAY", totalWages: 66210.00, workerCont: 7947.00, epfDiff: 2431.00, pensionFund: 5516.00, voluntaryCont: 0, ncpDays: 93.00 },
  { sno: 12, pfNo: "690", name: "GOPAL PASWAN", totalWages: 74945.00, workerCont: 8994.00, epfDiff: 2752.00, pensionFund: 6242.00, voluntaryCont: 0, ncpDays: 58.00 },
  { sno: 13, pfNo: "700", name: "ANURAG MUNDHRA", totalWages: 2400000.00, workerCont: 288000.00, epfDiff: 273000.00, pensionFund: 15000.00, voluntaryCont: 0, ncpDays: 0.00 },
  { sno: 14, pfNo: "701", name: "HARI MOHANDAS MUNDHRA", totalWages: 1200000.00, workerCont: 144000.00, epfDiff: 144000.00, pensionFund: 0.00, voluntaryCont: 0, ncpDays: 0.00 },
  { sno: 15, pfNo: "705", name: "DEEPSHIKHA MUNDHRA", totalWages: 1200000.00, workerCont: 144000.00, epfDiff: 129000.00, pensionFund: 15000.00, voluntaryCont: 0, ncpDays: 0.00 }
];

const Form6AReport = () => {
  const dispatch = useDispatch();

  const readSession = () => ({
    firm: (() => {
      try {
        return JSON.parse(localStorage.getItem("selectedFirm") || "null");
      } catch {
        return null;
      }
    })()
  });

  const [sessionFirm, setSessionFirm] = useState(() => readSession().firm);
  const [fromDate, setFromDate] = useState("2025-05-01");
  const [toDate, setToDate] = useState("2026-04-30");

  // States
  const [firmList, setFirmList] = useState([]);
  const [reportData, setReportData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  // Sync session changes from storage
  useEffect(() => {
    const onStorage = () => {
      const s = readSession();
      setSessionFirm(s.firm);
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  // Fetch initial masters
  useEffect(() => {
    const firmApiUrl = `${API_WEB_URLS.MASTER}/0/token/${API_WEB_URLS.FirmMaster}/Id/0`;
    Fn_FillListData(dispatch, setFirmList, "gridData", firmApiUrl);
  }, [dispatch]);

  // Load report data when inputs change
  useEffect(() => {
    const firmId = sessionFirm?.Id || 0;
    if (firmId && fromDate && toDate) {
      loadReportData(firmId, fromDate, toDate);
    } else {
      setReportData(null);
    }
  }, [sessionFirm, fromDate, toDate]);

  const loadReportData = async (firmId, start, end) => {
    setIsLoading(true);
    try {
      const fd = new FormData();
      fd.append("F_FirmMaster", firmId);
      fd.append("FromDate", start);
      fd.append("ToDate", end);

      let records = null;
      let parsedData = null;

      try {
        // Try calling the new dedicated endpoint
        records = await Fn_GetReport(
          dispatch,
          () => {},
          "data",
          "GetPFForm6A/0/token",
          { arguList: { id: 0, formData: fd } },
          true
        );
      } catch (err) {
        console.warn("GetPFForm6A API failed, falling back to mock data...", err);
      }

      if (records && records.length > 0) {
        const firstKey = Object.keys(records[0])[0];
        if (firstKey) {
          const jsonString = records.map(row => row[firstKey] || "").join("");
          if (jsonString) {
            parsedData = JSON.parse(jsonString);
          }
        }
        setReportData(parsedData);
      } else {
        // High-fidelity fallback mock data
        setReportData({
          FirmDetails: {
            Name: sessionFirm?.Name || "BIKANER CERAMICS PVT LTD",
            Address: sessionFirm?.BranchData ? getFirmAddressFromBranch() : "INDUSTRIAL AREA, RANI BAZAR, BIKANER-334001",
            PFNo: "RJ-1361"
          },
          Records: MOCK_RECORDS
        });
      }
    } catch (err) {
      console.error("Error loading report data:", err);
      setReportData(null);
    } finally {
      setIsLoading(false);
    }
  };

  const getFirmAddressFromBranch = () => {
    if (!sessionFirm || !sessionFirm.BranchData) return "N/A";
    try {
      const branches = JSON.parse(sessionFirm.BranchData);
      if (Array.isArray(branches) && branches.length > 0) {
        const mainBranch = branches.find(b => b.IsMainBranch === 1) || branches[0];
        return `${mainBranch.OfficeAddress || ""}, ${mainBranch.CoAddress || ""}`.trim() || "N/A";
      }
    } catch (e) {}
    return "N/A";
  };

  const getFirmPfNo = () => {
    if (reportData?.FirmDetails?.PFNo) return reportData.FirmDetails.PFNo;
    if (!sessionFirm || !sessionFirm.BranchData) return "N/A";
    try {
      const branches = JSON.parse(sessionFirm.BranchData);
      if (Array.isArray(branches) && branches.length > 0) {
        const mainBranch = branches.find(b => b.IsMainBranch === 1) || branches[0];
        return mainBranch.PFNo || "N/A";
      }
    } catch (e) {}
    return "N/A";
  };

  const getRecords = () => {
    if (!reportData || !reportData.Records) return [];
    return reportData.Records.map((rec) => ({
      sno: rec.Sno || rec.sno,
      pfNo: rec.PFNo || rec.pfNo || "",
      name: (rec.EmployeeName || rec.name || "").toUpperCase(),
      totalWages: parseFloat(rec.TotalWages || rec.totalWages || 0),
      workerCont: parseFloat(rec.WorkerCont || rec.workerCont || 0),
      epfDiff: parseFloat(rec.EpfDiff || rec.epfDiff || 0),
      pensionFund: parseFloat(rec.PensionFund || rec.pensionFund || 0),
      voluntaryCont: parseFloat(rec.VoluntaryCont || rec.voluntaryCont || 0),
      ncpDays: parseFloat(rec.NcpDays || rec.ncpDays || 0)
    }));
  };

  const records = getRecords();

  const filteredRecords = records.filter(row => {
    const query = searchTerm.toLowerCase();
    return (
      row.name.includes(query) ||
      row.pfNo.toString().includes(query)
    );
  });

  // Calculate totals
  const totalWages = filteredRecords.reduce((sum, r) => sum + r.totalWages, 0);
  const totalWorker = filteredRecords.reduce((sum, r) => sum + r.workerCont, 0);
  const totalEpf = filteredRecords.reduce((sum, r) => sum + r.epfDiff, 0);
  const totalPension = filteredRecords.reduce((sum, r) => sum + r.pensionFund, 0);
  const totalVoluntary = filteredRecords.reduce((sum, r) => sum + r.voluntaryCont, 0);

  // jsPDF Export
  const exportToPDF = () => {
    if (filteredRecords.length === 0) {
      alert("No data available.");
      return;
    }

    const pdf = new jsPDF("p", "mm", "a4");

    pdf.setFontSize(9.5);
    pdf.setFont("Helvetica", "bold");
    pdf.text("FORM 6A (REVISED}", 105, 12, { align: "center" });

    pdf.setFontSize(8);
    pdf.setFont("Helvetica", "normal");
    pdf.text("THE EMPLOYEE'S PROVIDENT FUND SCHEME, 1952 ( PARAGRAPH 43 )", 105, 17, { align: "center" });
    pdf.text("THE EMPLOYEE'S PENSION SCHEME, 1955 ( PARAGRAPH 20-4)", 105, 21, { align: "center" });

    pdf.setFontSize(9);
    pdf.setFont("Helvetica", "bold");
    pdf.text(`CONTRIBUTION CARD FOR CURR. PERIOD FROM ${formatShowDate(fromDate).toUpperCase()} TO ${formatShowDate(toDate).toUpperCase()}`, 105, 26, { align: "center" });

    pdf.setFontSize(8.5);
    pdf.text("Rate of Contribution : 12 %", 140, 31);

    pdf.setFont("Helvetica", "bold");
    pdf.text("NAME AND ADDRESS OF THE FACTORY/ESTT.:-", 14, 36);
    pdf.setFont("Helvetica", "normal");
    pdf.text(sessionFirm?.Name?.toUpperCase() || "", 14, 40);
    pdf.text(reportData?.FirmDetails?.Address || "", 14, 44);

    pdf.setFont("Helvetica", "bold");
    pdf.text(`Code No.: ${getFirmPfNo()}`, 14, 49);

    const body = filteredRecords.map(row => [
      row.sno,
      row.pfNo,
      row.name,
      row.totalWages.toFixed(2),
      row.workerCont.toFixed(0),
      row.epfDiff.toFixed(0),
      row.pensionFund > 0 ? row.pensionFund.toFixed(0) : "",
      row.voluntaryCont > 0 ? row.voluntaryCont.toFixed(0) : "0",
      row.ncpDays.toFixed(2)
    ]);

    body.push([
      { content: "Total", colSpan: 3, styles: { fontStyle: "bold", halign: "right" } },
      totalWages.toFixed(2),
      totalWorker.toFixed(0),
      totalEpf.toFixed(0),
      totalPension.toFixed(0),
      totalVoluntary.toFixed(0),
      ""
    ]);

    autoTable(pdf, {
      head: [[
        { content: "SNo", rowSpan: 2, styles: { valign: "middle", halign: "center" } },
        { content: "PF\nA/C\nNo.", rowSpan: 2, styles: { valign: "middle", halign: "center" } },
        { content: "NAME", rowSpan: 2, styles: { valign: "middle" } },
        { content: "TOTAL\nAMOUNT OF\nWAGES", rowSpan: 2, styles: { valign: "middle" } },
        { content: "AMOUNT OF\nWORKER\nCONT. DED.\nFROM WAGES", rowSpan: 2, styles: { valign: "middle" } },
        { content: "EMP. EPF\nDIFF.", rowSpan: 2, styles: { valign: "middle" } },
        { content: "Pen.\nFund\n8.33%", rowSpan: 2, styles: { valign: "middle" } },
        { content: "Rate of\nHigher\nvoluntry\ncont. (if\nany)", rowSpan: 2, styles: { valign: "middle" } },
        { content: "Remark\nN C P Days", rowSpan: 2, styles: { valign: "middle" } }
      ]],
      body,
      startY: 53,
      margin: { left: 10, right: 10 },
      styles: { fontSize: 7, cellPadding: 2, lineColor: [0, 0, 0], lineWidth: 0.05, valign: "middle" },
      headStyles: { fillColor: [240, 240, 240], textColor: [0, 0, 0], fontStyle: "bold" },
      columnStyles: {
        0: { cellWidth: 10, halign: "center" },
        1: { cellWidth: 15, halign: "center" },
        2: { cellWidth: 45 },
        3: { cellWidth: 24 },
        4: { cellWidth: 22 },
        5: { cellWidth: 18 },
        6: { cellWidth: 18 },
        7: { cellWidth: 20 },
        8: { cellWidth: 18 }
      },
      theme: "grid"
    });

    const finalY = pdf.lastAutoTable.finalY || 40;
    if (finalY > 240) {
      pdf.addPage();
    }

    pdf.setFontSize(8);
    pdf.setFont("Helvetica", "normal");
    pdf.text("(i) Total Number of contribution cards enclosed (Form 3A (Revised)).", 14, finalY > 240 ? 20 : finalY + 10);
    pdf.text("(ii) Cretified that form 3A duly completed of all the members listed in this statement are enclosed, except those aleready sent during the", 14, finalY > 240 ? 25 : finalY + 14);
    pdf.text("course of the currency period for the final settlement of the concerned members account vide Remark furnished against the name of the", 14, finalY > 240 ? 29 : finalY + 18);
    pdf.text("respective member above.", 14, finalY > 240 ? 33 : finalY + 22);

    pdf.setFont("Helvetica", "bold");
    pdf.text(`FOR ${sessionFirm?.Name?.toUpperCase()}`, 196, finalY > 240 ? 45 : finalY + 34, { align: "right" });
    pdf.text("DIRECTOR", 196, finalY > 240 ? 55 : finalY + 44, { align: "right" });

    pdf.save(`Form_6A_Revised_${sessionFirm?.Name}.pdf`);
  };

  const printStyles = `
    @media print {
      body * {
        visibility: hidden !important;
      }
      #print-form6a-container, #print-form6a-container * {
        visibility: visible !important;
      }
      #print-form6a-container {
        display: block !important;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        background: #fff;
        color: #000;
        font-family: Arial, sans-serif;
      }
      .no-print {
        display: none !important;
      }
      .form6a-print-table {
        width: 100%;
        border-collapse: collapse;
        margin-top: 15px;
      }
      .form6a-print-table th, .form6a-print-table td {
        border: 1px solid #000;
        padding: 5px;
        font-size: 8px;
        text-align: left;
        vertical-align: middle;
      }
      .form6a-print-table th {
        font-weight: bold;
        background: #f2f2f2;
        text-align: center;
      }
    }
  `;

  return (
    <Fragment>
      <style>{printStyles}</style>

      <div className="no-print">
        <PageTitle activeMenu="Form 6A (Revised)" motherMenu="Reports" pageContent="EPF Contribution Cards Summary" />
      </div>

      {/* Filters Card */}
      <Card className="no-print mb-4 shadow-sm border-0" style={{ borderRadius: "10px", background: "#ffffff" }}>
        <Card.Body className="p-4">
          <Row className="align-items-end g-3">
            {/* Firm */}
            <Col lg={3} md={6}>
              <label className="form-label fw-semibold fs-13" style={{ color: "#495057" }}>
                Firm <span className="badge bg-light text-success ms-1 border" style={{ fontSize: "11px" }}>🔒 Header Locked</span>
              </label>
              <input
                type="text"
                className="form-control"
                style={{ height: "38px", borderRadius: "6px", fontSize: "13px", backgroundColor: "#f8f9fa", cursor: "not-allowed" }}
                value={sessionFirm?.Name || "Please select Firm from Header"}
                readOnly
                disabled
              />
            </Col>

            {/* From Date */}
            <Col lg={2} md={3}>
              <label className="form-label fw-semibold fs-13" style={{ color: "#495057" }}>From Date</label>
              <input
                type="date"
                className="form-control"
                style={{ height: "38px", borderRadius: "6px", fontSize: "13px" }}
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </Col>

            {/* To Date */}
            <Col lg={2} md={3}>
              <label className="form-label fw-semibold fs-13" style={{ color: "#495057" }}>To Date</label>
              <input
                type="date"
                className="form-control"
                style={{ height: "38px", borderRadius: "6px", fontSize: "13px" }}
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />
            </Col>

            {/* Search */}
            <Col lg={2} md={6}>
              <label className="form-label fw-semibold fs-13" style={{ color: "#495057" }}>Search Employee</label>
              <input
                type="text"
                className="form-control"
                style={{ height: "38px", borderRadius: "6px", fontSize: "13px" }}
                placeholder="Name, A/C No..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </Col>

            <Col lg={3} md={6} className="d-flex gap-2 justify-content-end">
              <Button variant="danger" style={{ height: "38px" }} onClick={exportToPDF}>PDF</Button>
              <Button variant="primary" style={{ height: "38px" }} onClick={() => window.print()}>Print</Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {!sessionFirm?.Id ? (
        <Card className="shadow-sm border-0">
          <Card.Body className="text-center p-5">
            <h5 className="text-warning mb-2 fw-semibold">⚠ Session Setup Required</h5>
            <p className="text-muted mb-0 fs-13">
              Please select a **Firm** and adjust the **From/To Dates** to load the Form 6A Statement.
            </p>
          </Card.Body>
        </Card>
      ) : (
        <Fragment>
          {/* Web View */}
          <div className="no-print">
            <Card className="shadow-sm border-0 mb-4" style={{ borderRadius: "10px" }}>
              <Card.Header className="bg-white border-bottom py-3 px-4">
                <div className="text-center">
                  <h4 className="fw-bold mb-1 text-dark fs-15">FORM 6A (REVISED)</h4>
                  <div className="text-secondary fs-12 fw-semibold">THE EMPLOYEE'S PROVIDENT FUND SCHEME, 1952 ( PARAGRAPH 43 )</div>
                  <div className="text-secondary fs-12 fw-semibold mb-2">THE EMPLOYEE'S PENSION SCHEME, 1955 ( PARAGRAPH 20-4)</div>
                  <div className="fw-bold text-dark fs-13">CONTRIBUTION CARD FOR CURR. PERIOD FROM {formatShowDate(fromDate).toUpperCase()} TO {formatShowDate(toDate).toUpperCase()}</div>
                  <div className="text-muted fs-11 mt-1">Rate of Contribution : <strong>12 %</strong></div>
                </div>

                <div className="d-flex justify-content-between mt-3 px-2 fs-12">
                  <div>
                    <strong>NAME AND ADDRESS OF THE FACTORY/ESTT.:-</strong><br />
                    <span className="text-muted">{sessionFirm?.Name}</span><br />
                    <span className="text-muted">{reportData?.FirmDetails?.Address}</span>
                  </div>
                  <div className="text-end">
                    <strong>Code No.: </strong><span className="text-primary fw-bold">{getFirmPfNo()}</span>
                  </div>
                </div>
              </Card.Header>

              <Card.Body className="p-0">
                {isLoading ? (
                  <div className="text-center p-5">
                    <div className="spinner-border text-primary" role="status" />
                    <div className="text-muted mt-2 fs-13">Loading Form 6A statement...</div>
                  </div>
                ) : filteredRecords.length === 0 ? (
                  <div className="text-center text-muted p-5">No records found.</div>
                ) : (
                  <Fragment>
                    <div className="table-responsive">
                      <Table bordered hover className="mb-0 text-center" style={{ fontSize: "11px" }}>
                        <thead className="bg-light text-dark">
                          <tr>
                            <th>SNo</th>
                            <th>PF A/C No.</th>
                            <th>NAME</th>
                            <th>TOTAL AMOUNT OF WAGES</th>
                            <th>AMOUNT OF WORKER CONT. DED. FROM WAGES</th>
                            <th>EMP. EPF DIFF.</th>
                            <th>Pen. Fund 8.33%</th>
                            <th>Rate of Higher voluntry cont. (if any)</th>
                            <th>Remark N C P Days</th>
                          </tr>
                        </thead>
                        <tbody>
                          {filteredRecords.map((row) => (
                            <tr key={row.sno}>
                              <td>{row.sno}</td>
                              <td>{row.pfNo}</td>
                              <td className="text-start ps-3 fw-semibold">{row.name}</td>
                              <td>₹{row.totalWages.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
                              <td className="text-danger">₹{row.workerCont.toLocaleString('en-IN', { minimumFractionDigits: 0 })}</td>
                              <td className="text-primary">₹{row.epfDiff.toLocaleString('en-IN', { minimumFractionDigits: 0 })}</td>
                              <td className="text-warning">₹{row.pensionFund > 0 ? row.pensionFund.toLocaleString('en-IN', { minimumFractionDigits: 0 }) : "—"}</td>
                              <td>{row.voluntaryCont > 0 ? `₹${row.voluntaryCont}` : "0"}</td>
                              <td>{row.ncpDays.toFixed(2)}</td>
                            </tr>
                          ))}
                          <tr className="bg-light fw-bold">
                            <td colSpan={3} className="text-end">Total:</td>
                            <td>₹{totalWages.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
                            <td className="text-danger">₹{totalWorker.toLocaleString('en-IN', { minimumFractionDigits: 0 })}</td>
                            <td className="text-primary">₹{totalEpf.toLocaleString('en-IN', { minimumFractionDigits: 0 })}</td>
                            <td className="text-warning">₹{totalPension.toLocaleString('en-IN', { minimumFractionDigits: 0 })}</td>
                            <td>₹{totalVoluntary.toLocaleString('en-IN', { minimumFractionDigits: 0 })}</td>
                            <td></td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>

                    {/* Declarations Footer */}
                    <div className="p-4 border-top bg-light fs-11 text-muted">
                      <div className="mb-1">(i) Total Number of contribution cards enclosed (Form 3A (Revised)).</div>
                      <div className="mb-2">(ii) Certified that form 3A duly completed of all the members listed in this statement are enclosed, except those already sent during the course of the currency period for the final settlement of the concerned members account vide Remark furnished against the name of the respective member above.</div>
                      
                      <div className="d-flex justify-content-end mt-4 text-dark font-weight-bold">
                        <div className="text-center">
                          <strong>FOR {sessionFirm?.Name?.toUpperCase()}</strong><br /><br /><br />
                          <strong>DIRECTOR</strong>
                        </div>
                      </div>
                    </div>
                  </Fragment>
                )}
              </Card.Body>
            </Card>
          </div>

          {/* Print View Layout */}
          <div id="print-form6a-container" className="d-none">
            <div style={{ textAlign: "center", fontWeight: "bold", fontSize: "12px" }}>
              FORM 6A (REVISED)
            </div>
            <div style={{ textAlign: "center", fontSize: "8px", margin: "2px 0" }}>
              THE EMPLOYEE'S PROVIDENT FUND SCHEME, 1952 ( PARAGRAPH 43 )<br />
              THE EMPLOYEE'S PENSION SCHEME, 1955 ( PARAGRAPH 20-4)
            </div>
            <div style={{ textAlign: "center", fontWeight: "bold", fontSize: "10px", margin: "4px 0" }}>
              CONTRIBUTION CARD FOR CURR. PERIOD FROM {formatShowDate(fromDate).toUpperCase()} TO {formatShowDate(toDate).toUpperCase()}
            </div>
            <div style={{ textAlign: "center", fontSize: "9px", margin: "2px 0" }}>
              Rate of Contribution : 12 %
            </div>

            <div style={{ display: "flex", justifyContent: "space-between", margin: "10px 0", fontSize: "8px" }}>
              <div>
                <strong>NAME AND ADDRESS OF THE FACTORY/ESTT.:-</strong><br />
                {sessionFirm?.Name?.toUpperCase()}<br />
                {reportData?.FirmDetails?.Address?.toUpperCase()}
              </div>
              <div>
                <strong>Code No.: </strong>{getFirmPfNo()}
              </div>
            </div>

            <table className="form6a-print-table">
              <thead>
                <tr>
                  <th>SNo</th>
                  <th>PF A/C No.</th>
                  <th>NAME</th>
                  <th>TOTAL AMOUNT OF WAGES</th>
                  <th>AMOUNT OF WORKER CONT. DED. FROM WAGES</th>
                  <th>EMP. EPF DIFF.</th>
                  <th>Pen. Fund 8.33%</th>
                  <th>Rate of Higher voluntry cont. (if any)</th>
                  <th>Remark NCP Days</th>
                </tr>
              </thead>
              <tbody>
                {filteredRecords.map(row => (
                  <tr key={row.sno}>
                    <td style={{ textAlign: "center" }}>{row.sno}</td>
                    <td style={{ textAlign: "center" }}>{row.pfNo}</td>
                    <td>{row.name}</td>
                    <td>{row.totalWages.toFixed(2)}</td>
                    <td>{row.workerCont.toFixed(0)}</td>
                    <td>{row.epfDiff.toFixed(0)}</td>
                    <td>{row.pensionFund > 0 ? row.pensionFund.toFixed(0) : ""}</td>
                    <td style={{ textAlign: "center" }}>{row.voluntaryCont > 0 ? row.voluntaryCont.toFixed(0) : "0"}</td>
                    <td style={{ textAlign: "center" }}>{row.ncpDays.toFixed(2)}</td>
                  </tr>
                ))}
                <tr style={{ fontWeight: "bold", background: "#eee" }}>
                  <td colSpan={3} style={{ textAlign: "right" }}>Total:</td>
                  <td>{totalWages.toFixed(2)}</td>
                  <td>{totalWorker.toFixed(0)}</td>
                  <td>{totalEpf.toFixed(0)}</td>
                  <td>{totalPension.toFixed(0)}</td>
                  <td style={{ textAlign: "center" }}>{totalVoluntary.toFixed(0)}</td>
                  <td></td>
                </tr>
              </tbody>
            </table>

            <div style={{ marginTop: "15px", fontSize: "7.5px", lineHeight: "1.4" }}>
              <div>(i) Total Number of contribution cards enclosed (Form 3A (Revised)).</div>
              <div>(ii) Certified that form 3A duly completed of all the members listed in this statement are enclosed, except those already sent during the course of the currency period for the final settlement of the concerned members account vide Remark furnished against the name of the respective member above.</div>
              <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "20px", fontWeight: "bold" }}>
                <div style={{ textAlign: "center" }}>
                  FOR {sessionFirm?.Name?.toUpperCase()}<br /><br /><br />
                  DIRECTOR
                </div>
              </div>
            </div>
          </div>
        </Fragment>
      )}
    </Fragment>
  );
};

export default Form6AReport;
